module.exports = __webpack_public_path__ + "assets/3da4cc3266e6ae8aa77472cc3414b0a2.png";